/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  UnproxiedMcpServerUserUsageRow,
  UnproxiedMcpServerUserUsageRow$inboundSchema,
} from "./unproxiedmcpserveruserusagerow.js";

/**
 * Result of a Shadow-MCP-backed per-user usage lookup for an unproxied MCP server
 */
export type GetUnproxiedMcpServerUserUsageResult = {
  /**
   * Cursor for next page
   */
  nextCursor?: string | undefined;
  users: Array<UnproxiedMcpServerUserUsageRow>;
};

/** @internal */
export const GetUnproxiedMcpServerUserUsageResult$inboundSchema: z.ZodMiniType<
  GetUnproxiedMcpServerUserUsageResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    users: z.array(UnproxiedMcpServerUserUsageRow$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function getUnproxiedMcpServerUserUsageResultFromJSON(
  jsonString: string,
): SafeParseResult<GetUnproxiedMcpServerUserUsageResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      GetUnproxiedMcpServerUserUsageResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetUnproxiedMcpServerUserUsageResult' from JSON`,
  );
}
